import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getFormXml } from '../../store/selectors/form.selector';
import { FormsState } from '../../store/state/pace-forms.state';
import { formatXml } from '../../utilities/xml-formatting-utilities';

@Component({
    selector: 'pace-forms-xml-renderer',
    templateUrl: './xml-renderer.component.html',
    styleUrls: ['./xml-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XmlRendererComponent {
    public readonly xml$: Observable<string[]>;
    public constructor(private readonly store: Store<FormsState>) {
        this.xml$ = this.store.select(getFormXml).pipe(map((xml) => formatXml(xml).split('\n')));
    }

    public trackByFn(index: number): number {
        return index;
    }
}
